import styled from "styled-components";
import MenuItem from "@material-ui/core/MenuItem";

export default styled(MenuItem)({});
